// Trạng thái các bước
export default {
  Process: 1,
  Done: 2,
  None: 3,
}
